'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
var screenReader = require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var baseCaption = require('../base-table/base-caption.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledCaption = (props)=>{
    const { breakpoints , children , className , showCaption =false , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseCaption.BaseCaption, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-table__standard-caption': true,
            'bf-table__standard-caption--breakpoints': !!breakpoints,
            'bf-table__standard-caption--hidden': !showCaption,
            [`${className}`]: !!className
        })
    }), children);
};
const blockCaption = styled.css`
  display: block;
`;
const tableCaption = styled.css`
  display: table-caption;
`;
const getCaptionBreakpoints = (breakpoints)=>{
    return breakpoints.map((breakpoint, index)=>{
        return styled.css`
      @media (min-width: ${breakpoint}px) {
        ${index % 2 === 0 ? tableCaption : blockCaption}
      }
    `;
    });
};
const StyledCaption = styled__default.default(UnstyledCaption)`
  ${blockCaption}
  box-sizing: border-box;
  caption-side: top;
  font-family: ${fonts.fontFamilyBold};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  padding: 15px;
  text-align: left;
  ${({ breakpoints  })=>getCaptionBreakpoints(breakpoints || [])}
  ${({ showCaption  })=>showCaption ? '' : screenReader.screenReaderOnly}
`;
/**
 * A summary of your `<table>`. Required for accessibility.
 * `showCaption={false}` (the default) hides the caption for sighted users with CSS.
 * @param props CaptionProps
 * @returns FunctionComponent<CaptionProps>
 */ const Caption = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledCaption, _extends({}, props)));
};

exports.Caption = Caption;
//# sourceMappingURL=caption.js.map
